module.exports = __webpack_public_path__ + "img/zldx-logo.f7b0f060.png";